var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exhibition-hall-div"},_vm._l((_vm.picList),function(item){return _c('img',{staticClass:"pic-list",attrs:{"src":item},on:{"click":function($event){return _vm.openDetails(item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }